var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFaq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_faq",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_134",
    "data-name": "Ellipse 134",
    d: "M13,2A11,11,0,0,0,5.222,20.778,11,11,0,1,0,20.778,5.222,10.928,10.928,0,0,0,13,2m0-2A13,13,0,1,1,0,13,13,13,0,0,1,13,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2005",
    "data-name": "Path 2005",
    d: "M2.773-2.839a3.5,3.5,0,0,1,.4-1.747,1.988,1.988,0,0,1,.334-.494,6.16,6.16,0,0,1,.5-.452q.461-.394.716-.656a1.75,1.75,0,0,0,.362-.6,2.151,2.151,0,0,0,.1-.68,1.193,1.193,0,0,0-.22-.773,1.041,1.041,0,0,0-.479-.356,1.857,1.857,0,0,0-.665-.114,2.006,2.006,0,0,0-.551.073,1.082,1.082,0,0,0-.427.224A1.009,1.009,0,0,0,2.535-8a1.224,1.224,0,0,0-.086.532H.7A3.478,3.478,0,0,1,1.079-8.76,2.57,2.57,0,0,1,1.885-9.7a2.969,2.969,0,0,1,.882-.432,3.4,3.4,0,0,1,.992-.148,4.172,4.172,0,0,1,1.46.245,2.513,2.513,0,0,1,1.088.763,2.561,2.561,0,0,1,.468.811,2.763,2.763,0,0,1,.165.943,2.833,2.833,0,0,1-.286,1.257,4.53,4.53,0,0,1-.8,1.126q-.214.228-.482.476-.227.207-.358.349a2.056,2.056,0,0,0-.227.293,1.726,1.726,0,0,0-.22.514,3.773,3.773,0,0,0-.041.659Zm1.756,2.7H2.787v-1.83H4.529Z",
    transform: "translate(9.18 18.207)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFaq);
export default __webpack_public_path__ + "static/media/icon_faq.d2c7426189e75616be8610932d476737.svg";
export { ForwardRef as ReactComponent };